var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"effect-chain-editor"},[_c('div',{staticClass:"case-logic-builder-container"},[_c('case-logic',{attrs:{"editor-id":_vm.editorId,"case-conf":_vm.effectChainCaseConf,"advanced-controls":false,"user":_vm.user,"readonly":_vm.readonly,"is-global":!_vm.caseConf,"available-nodes":['Timer', 'Check', 'Effect', 'Frame']},on:{"update":function (ref) {
	var caseLogicDescription = ref.caseLogicDescription;

	return _vm.updateEffectChain(caseLogicDescription);
}}}),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }